"use client"
import AppLayout from '@/components/app/applayout';
import Appartments from '@/components/portfolio/apartments';
import Expolore from '@/components/portfolio/expolore';
import OwnProperty from '@/components/portfolio/ownProperty';
import { appResponse, getPortfolioApi, pxToRem } from '@/util';
import { ExtendedPortfolio, } from '@/util/types/portfolio';
import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React from 'react'
import { makeStyles } from 'tss-react/mui'

export default function Portfolio() {
  const {classes}=styles();
   const limit=5;
   const [page,setPage]=React.useState<number>(1);
  const [location,setLocation]=React.useState<string>("");
  const [propertyType,setPropertyType]=React.useState<string>("");
  const [year,setYear]=React.useState<string>("");
  const [sort,setSort]=React.useState<string>("newest");
  const[propertyName,setPropertyName]=React.useState<string>("");
    const { data, isLoading, isError, error,refetch,isRefetching } = useQuery<appResponse<ExtendedPortfolio[]>>({
    queryKey: ["portfolio", {page}],
    queryFn: () => getPortfolioApi({ page, limit,propertyType,sort,location,year,name:propertyName}),
    select: (data) => ({
      ...data,
      payload: data.payload.map((item): ExtendedPortfolio => {
        const property =
          typeof item.property === "object" && item.property !== null
            ? item.property
            : {};

        const media =
          Array.isArray(property.media) &&
          typeof property.media[0] === "object" &&
          property.media[0] !== null
            ? property.media[0]
            : undefined;

        return {
          ...item,
          name: `${property.name || ""} -`,
          city: property.city || "",
          state: property.state || "",
          description: property.description || "",
          details: `${property.propertyType || "N/A"} | Completed in ${
            property.yearbuilt || "N/A"
          }`,
          image: media?.url || "/placeholder.jpg",
          location: `${property.city || "Unknown City"}, ${
            property.state || ""
          }`,
          propertyType: property.propertyType || "N/A",
          media: Array.isArray(property.media)
            ? (property.media
                .map((m) =>
                  typeof m === "object" && m?.url ? { url: m.url } : null
                )
                .filter(Boolean) as { url: string }[])
            : [],
        };
      }),
    }),
    refetchOnWindowFocus: false,
  });

    return (
   <AppLayout>
    <Box className={`${classes.container} `}>
    <Expolore 
    propertyName={propertyName} 
    setPropertyName={(e)=>setPropertyName(e)}
    handleSearch={()=>refetch()}
     sort={sort} 
     setSort={(e:string)=>setSort(e)} 
     year={year} 
     setYear={(e:string)=>setYear(e)} 
     propertyType={propertyType} 
     setPropertyType={(e:string)=>setPropertyType(e)}
      location={location} 
      setLocation={(e:string)=>setLocation(e)}
      />
     <Appartments  
     setPage={(e:number)=>setPage(e)}
      error={error?.message} data={data} isError={isError} isLoading={isLoading||isRefetching}/>
     <OwnProperty/>
    </Box>
   </AppLayout>
  )
}

const styles=makeStyles()(()=>({
    container:{
     display:'flex',
     flex:1,
     flexDirection:'column',
     minHeight:pxToRem(500),
    },
    debug:{
        border:'1px solid red'
    }
}))
